import Typography from "@mui/material/Typography";

const NimKoreh = () => {
  return (
    <>
      <Typography sx={{ textAlign: "justify" }}>
        گرانول‌های آلومینیومی که در صنعت فولادسازی مورد استفاده قرار می‌گیرد
        دارای خلوص مختلف بوده و بصورت کره یا نیم کره تولید می‌گردد. گرانول‌های
        تولیدی شرکت نگین آلومینیوم گلپایگان با سایزهای مورد نظر مشتری و با خلوص
        مورد تایید آنها و در کیسه‌های یک تنی تولید و عرضه می‌گردد.
      </Typography>
    </>
  );
};

export default NimKoreh;
